import React, {useState} from 'react';
import RenderIf from "@/components/render-if";
import StudentLayout from "@/components/layout/student/studentLayout";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {useApiNotifications} from "@/api/notification";
import {Empty, Pagination, Spin} from "antd";
import NotificationCard from "@/pages/notification/_section/NotificationCard";
import FreeBox from "@/components/box/freeBox";
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";

function NotificationsPage({module}) {

    const [page, setPage] = useState(1);

    const {data, isPending, isSuccess, refetch, isRefetching} = useApiNotifications({page: page})

    const NotificationPageElement = (
        <>
            <RenderIf condition={isPending}>
                <div className="flex justify-center ">
                    <Spin className={'text-center'} spinning={true}/>
                </div>
            </RenderIf>
            <RenderIf condition={isSuccess && data?.data?.data?.length === 0}>
                <FreeBox>
                    <Empty/>
                </FreeBox>
            </RenderIf>

            <RenderIf condition={isSuccess && data?.data?.data?.length > 0}>
                {data?.data?.data?.map((notification, index) => (
                    <NotificationCard
                        isProcessing={isPending || isRefetching}
                        notification={notification}
                        key={'notification' + notification.id}
                        refetch={refetch}
                    />
                ))}
                <Pagination
                    current={page}
                    total={data?.meta?.total}
                    pageSize={data?.meta?.per_page}
                    onChange={(newPage) => setPage(newPage)}
                />

            </RenderIf>


        </>
    );

    const pageTitle = "اطلاع‌رسانی";

    return (<>
        <RenderIf condition={module === 'student'}>
            <StudentLayout pageTitle={pageTitle} backTo={URLS.student.dashboard}>
                {NotificationPageElement}
            </StudentLayout>
        </RenderIf>
        <RenderIf condition={module === 'admin'}>
            <AdminLayout pageTitle={pageTitle} backTo={URLS.admin.dashboard}>
                {NotificationPageElement}
            </AdminLayout>
        </RenderIf>
        <RenderIf condition={module === 'teacher'}>
            <TeacherLayout pageTitle={pageTitle} backTo={URLS.teacher.dashboard}>
                {NotificationPageElement}
            </TeacherLayout>
        </RenderIf>
    </>)
}

export default NotificationsPage;